import script from "./SurveyBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyBuilder.vue?vue&type=script&setup=true&lang=js"

import "./SurveyBuilder.vue?vue&type=style&index=0&id=0034546b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0034546b"]])

export default __exports__